import { ComponentRepresentation } from '@ardoq/basic-components';
import { ComponentItemContainer, ComponentLabel, IconContainer } from './atoms';
import { classes } from '@ardoq/common-helpers';
import { BodyCellItemModel } from '../types';
import { COMPONENT_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { TruncatedTextPopover } from '@ardoq/popovers';
import { componentMatrixCommands } from '../commands';
import { dispatchAction } from '@ardoq/rxbeach';
import { setComponentId } from 'streams/context/ContextActions';
import { useHoveredItemHandlers } from '../useHoveredItemHandlers';

interface ComponentItemArgs extends BodyCellItemModel {
  isHighlighted: boolean;
}
const ComponentItem = ({
  componentId,
  iconColor,
  componentLabel,
  className,
  representationData,
  isContext,
  isHighlighted,
}: ComponentItemArgs) => {
  const { onMouseEnter, onMouseLeave } = useHoveredItemHandlers(componentId);

  return (
    <ComponentItemContainer
      {...{ [COMPONENT_ID_ATTRIBUTE]: componentId }}
      role="button"
      aria-label={`Component ${componentLabel}`}
      className={classes(
        className,
        'skipContextUpdate',
        isHighlighted && 'active',
        isContext && 'context'
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={e => {
        e.stopPropagation();
        componentMatrixCommands.setFocusedItemState(componentId);
      }}
      onDoubleClick={() => dispatchAction(setComponentId(componentId))}
    >
      <IconContainer $color={iconColor}>
        <ComponentRepresentation
          isImage={representationData.isImage}
          value={representationData.value}
          icon={representationData.icon}
        />
      </IconContainer>
      <ComponentLabel>
        <TruncatedTextPopover>{componentLabel}</TruncatedTextPopover>
      </ComponentLabel>
    </ComponentItemContainer>
  );
};

export { ComponentItem };
